import { useEffect } from 'react'

import { useParams } from 'react-router-dom'
import debounce from 'lodash/debounce'

import FirebaseService from 'modules/firebase/service/firebaseService'
import { useTriggerRequest } from 'modules/trigger/hooks/useTriggerRequest'

const DEBOUNCE_WAIT_MS = 500
const DELAY_TO_REFETCH = 5000

const firebase = new FirebaseService()

export const useRealtimeDb = () => {
  const { hash: liveCode } = useParams<{ hash: string }>()

  const { refetch: refetchTriggers } = useTriggerRequest()

  useEffect(() => {
    const handleRefetchTriggers = debounce(() => {
      setTimeout(() => {
        refetchTriggers()
      }, DELAY_TO_REFETCH)
    }, DEBOUNCE_WAIT_MS)

    const ref = firebase.addTriggerListener(liveCode, async () => {
      handleRefetchTriggers()
    })

    return () => {
      firebase.removeListener(ref)
    }
  }, [liveCode, refetchTriggers])
}
